<template>
    <div class="session-callback">
        <div class="session-callback__panel">
            <h1 class="session-callback__title">{{ title }}</h1>
            <p class="session-callback__body">{{ message }}</p>
            <button v-if="showClose" type="button" class="btn btn-secondary btn-sm" @click="closeSelf">
                Close
            </button>
        </div>
    </div>
</template>

<script>
import { SESSION_REFRESH_CHANNEL, SESSION_REFRESH_MESSAGE } from '../utils/sessionRefreshPopup'

/**
 * Landing page for the session-refresh popup (see utils/sessionRefreshPopup.js).
 *
 * The auth service redirects here after a successful re-login. The token comes
 * back as `?tkn=` (as on a normal login landing on Home); if the service set
 * the cookie instead, the cookie is shared with the opener and read from there.
 * This page only relays the token — the portal window validates it and writes the
 * cookies, since it holds the store and the current user to compare against.
 */
export default {
    name: 'SessionRefreshCallback',
    data() {
        return {
            title: 'Signing you in',
            message: 'Renewing your session…',
            showClose: false,
        }
    },
    mounted() {
        const params = new URLSearchParams(window.location.search)
        const token = params.get('tkn') || this.$cookies.get('access-token')
        const payload = token
            ? { type: SESSION_REFRESH_MESSAGE, token }
            : { type: SESSION_REFRESH_MESSAGE, error: params.get('error') || 'Sign-in did not return a new session.' }

        // BroadcastChannel is same-origin only and, unlike window.opener,
        // survives the provider's sign-in page severing the popup from the portal.
        const channel = new BroadcastChannel(SESSION_REFRESH_CHANNEL)
        channel.postMessage(payload)
        channel.close()

        this.title = token ? 'Session renewed' : 'Session not renewed'
        this.message = token
            ? 'You can close this window and return to the portal.'
            : `${payload.error} Close this window and try again.`
        this.showClose = true
        // A severed popup may refuse window.close(); the button and message cover that.
        if (token) setTimeout(() => this.closeSelf(), 150)
    },
    methods: {
        closeSelf() {
            try {
                window.close()
            } catch (e) {
                this.message = 'You can close this window now.'
            }
        },
    },
}
</script>

<style scoped>
.session-callback {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 2rem;
    text-align: center;
}

.session-callback__panel {
    max-width: 26rem;
}

.session-callback__title {
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.session-callback__body {
    font-size: 0.875rem;
    opacity: 0.8;
    margin-bottom: 1rem;
}
</style>
